import * as types from './types';
import {
  AdminToolBookStatementTeacherList,//教师列表
  AdminToolBookStatementTeacherDelete,//删除教师
  AdminToolBookStatementTeacherEditModel,//教师编辑
} from 'src/model/AdminModel';

export default{
  actionAdminToolBookStatementTeacherList({commit, state}, query){
    if (state.adminToolBookStatementTeacherList === 'loading'){
      return Promise.reject();
    }
    commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST, {
      state: 'loading'
    });
    return AdminToolBookStatementTeacherList.getInstance().execute(query).then((response) => {
      commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST, {
        ...response,
        state: 'loadend',
        'list': response.list
      });
      return response;
    }).catch((err) => {
      commit(types.ACTION_ADMIN_TOOL_BOOK_STATEMENT_TEACHER_LIST, {
        state: 'loaderr'
      });
      return Promise.reject(err);
    });
  },

  actionAdminToolBookStatementTeacherDelete({commit, state}, query){
    return AdminToolBookStatementTeacherDelete.getInstance().execute(query);
  },
  actionAdminToolBookStatementTeacherEditModel({commit, state}, query){
    return AdminToolBookStatementTeacherEditModel.getInstance().execute(query);
  },
}






// WEBPACK FOOTER //
// ./src/store/Admin/modules/teacherInformationSheet/actions.js